"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

function isPreview(src) {
  return !/^(?:http(s)?:\/\/)/.test(src);
} // used only for placeholder calculations


function handleImageDimension(value) {
  if (/^\d+$/.test(value)) {
    value = "".concat(value, "px");
  }

  if (/%$/.test(value)) {
    return "100%";
  }

  return value;
} // used only for placeholder calculations


function placeholderDimension(src, value, calculatedValue) {
  if (isPreview(src)) {
    if (!value || value === "" || /%$/.test(value)) {
      return "";
    }

    return handleImageDimension(value);
  }

  return "".concat(calculatedValue, "px");
}

var ImagePreview = function ImagePreview(_ref) {
  var classes = _ref.classes,
      _ref$content$attrs = _ref.content.attrs,
      src = _ref$content$attrs.src,
      width = _ref$content$attrs.width,
      height = _ref$content$attrs.height,
      alt = _ref$content$attrs.alt,
      calculatedWidth = _ref$content$attrs.calculatedWidth,
      calculatedHeight = _ref$content$attrs.calculatedHeight,
      title = _ref$content$attrs.title,
      url = _ref$content$attrs.url,
      isEditor = _ref.internals.isEditor;

  var img = /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.root,
    src: src,
    width: placeholderDimension(src, width, calculatedWidth),
    height: placeholderDimension(src, height, calculatedHeight),
    alt: alt,
    title: title
  }));

  if (!url) {
    return img;
  }

  return /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    title: title,
    onClick: function onClick(e) {
      if (isEditor) {
        e.preventDefault();
      }
    }
  }, img);
};

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    imageWrapper: {
      display: "inline-block",
      verticalAlign: "bottom",
      "@media only screen and (max-width: 675px)": {
        height: "auto !important"
      }
    },
    root: {
      maxWidth: "100%",
      width: function width(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs && placeholderDimension(attrs.src, attrs.width, attrs.calculatedWidth);
      },
      height: function height(_ref3) {
        var attrs = _ref3.content.attrs;
        return attrs && placeholderDimension(attrs.src, attrs.height, attrs.calculatedHeight);
      },
      display: "block",
      "@media only screen and (max-width: 675px)": {
        height: "auto !important"
      }
    }
  };
})(ImagePreview);

exports["default"] = _default;